import { ReactNode, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'

const connectorwidth = 1.5
const shadowsize = 2

const isMobile = window.innerWidth < 712
const rectheight = isMobile?24:36


const prority_styles = {
  1: {
    backgroundColor: 'var(--brandblue-main)',
    color: '#fff',
    fontSize: 18,
    letterSpacing: 0.5,
    fontWeight: 400,
    padding: 15,
    stroke: 'var(--brandblue-main)',
  },
  2: {
    backgroundColor: 'var(--anno-transp-bg)',
    color: 'var(--anno-text-color)',
    fontSize:  isMobile?14:15,
    letterSpacing: 0.5,
    fontWeight: 700,
    padding: 15,
    stroke: 'var(--brandblue-main)',
  },
  3: {
    backgroundColor: 'var(--anno-transp-bg)',
    color: 'var(--anno-text-color)',
    fontSize: isMobile?12:15,
    letterSpacing: 0.5,
    fontWeight: 400,
    padding: 5,
    stroke: 'var(--brandblue-main)',
  },
  4: {
    backgroundColor: '#fff',
    color: 'var(--anno-text-color)',
    fontSize: 18,
    letterSpacing: 0.5,
    fontWeight: 400,
    padding: 15,
    stroke: 'var(--beige-main)',
  },
}

const Annotation = ({
  children,
  align = 'start',
  direction = 'top',
  hasConnector = true,
  hasBackground = true,
  offset = 50,
  padding = 15,
  backgroundColor = 'var(--brandblue-main)',
  position = { x: 0, y: 0 },
  priority = 1,
  exactLocation = false,
}: {
  children: ReactNode
  align?: 'start' | 'end' | 'middle'
  direction?: 'top' | 'bottom'
  hasConnector?: boolean
  hasBackground?: boolean
  offset?: number
  padding?: number
  backgroundColor?: string
  position?: { x: number; y: number }
  priority?: 1 | 2 | 3 | 4
  exactLocation?: boolean
}) => {
  const [labelwidth, setLabelwidth] = useState<number>(0)
  const svgtextref = useRef<SVGTextElement>(null)
  useEffect(() => {
    if (svgtextref.current) {
      setLabelwidth(
        svgtextref.current.getBBox().width +
          2 * prority_styles[priority].padding
      )
    }
  }, [svgtextref.current?.getBBox()])

  const connector_x =
    priority === 3
      ? align === 'middle'
        ? 0
        : align === 'end'
        ? 4
        : -4
      : align === 'middle'
      ? 0
      : align === 'end'
      ? -1
      : 1
  const background_x =
    align === 'middle' ? -labelwidth / 2 : align === 'end' ? -labelwidth : 0
  const text_x =
    align === 'middle'
      ? 0
      : align === 'end'
      ? -prority_styles[priority].padding
      : prority_styles[priority].padding

  return (
    <g
      transform={`translate(${position.x},${
        position.y + (direction === 'top' ? 0 : 100)
      })`}
    >
      {hasBackground && (
        <AnnoBackground
          x={background_x}
          y={isMobile?-15:-24}
          height={rectheight}
          width={labelwidth + (exactLocation ? 0 : 4)}
          fill={prority_styles[priority].backgroundColor}
        />
      )}{' '}
      {exactLocation && (
        <>
          <AnnoConnectorBG
            x1={connector_x}
            x2={connector_x}
            y1={direction === 'top' ? 15 : -15}
            y2={direction === 'top' ? offset : -offset - rectheight / 2}
          />
          <AnnoConnector
            x1={connector_x}
            x2={connector_x}
            y1={
              priority === 3 || priority === 2
                ? direction === 'top'
                  ? align !== 'middle'
                    ? -rectheight / 2 - 5
                    : rectheight / 2 - 5
                  : align !== 'middle'
                  ? rectheight / 2 - 5
                  : -rectheight / 2 - 5
                : direction === 'top'
                ? 12
                : -12
            }
            y2={direction === 'top' ? offset : -offset - rectheight / 2}
            stroke={prority_styles[priority].stroke}
          />
        </>
      )}

      <Text
        x={text_x}
        ref={svgtextref}
        textAnchor={align}
        style={{
          fill: prority_styles[priority].color,
          fontSize: prority_styles[priority].fontSize,
          fontWeight: prority_styles[priority].fontWeight,
          letterSpacing: prority_styles[priority].letterSpacing,
          fontStyle: exactLocation ? 'regular' : 'italic',
        }}
      >
        {children}
      </Text>
    </g>
  )
}

const AnnoConnector = styled.line`
  stroke-width: ${2.25}px;
`
const AnnoConnectorBG = styled.line`
  /* stroke: #fff; */
  stroke-width: ${connectorwidth + 3}px;
  stroke-linecap: round;
`

const AnnoBackground = styled.rect``


const Text = styled.text`

  color: var(--text-color);
  font-weight: 400;
  letter-spacing: 1px;
  font-size: 18px;
  @media screen and (max-width: 712px) {
    font-size: 12px;
  }
`

export default Annotation
